import {
    postData,
    getDataWithParams,
    destroyData,
    getData,
    patchData
} from '@/store/config/method'
const initialState = () => ({
    item: {},
    list: {last_page: 0, data: [], total: 0},
    list2: {last_page: 0, data: [], total: 0},
    company: { jobVacancies: []},
    request: {
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null,
    },
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getItem: state => state.item,
    getList: state => state.list,
    getList2: state => state.list2,
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getCompany: state => state.company,
}

const actions = {
    async fetchData({
        commit
    }, url) {
        try {
            var response = await getData(`/${url}`);
            commit('SET_ITEM', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getCompanyDetail({
        commit
    }, slug) {
        try {
            var response = await getData(`/company-detail/${slug}`);
            commit('SET_COMPANY', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getActiveData({
        commit, state
    }, request) {
        try {
            var response = await getDataWithParams('/event-data/active/company',request);
            state.request2 = request
            commit('SET_LIST2', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getListData({
        commit, state
    }, {url, request}) {
        try {
            var response = await getDataWithParams(`/${url}`,request);
            state.request = request
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submit({
        commit, state
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async postdata({
        commit
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async destroy({
        commit, state
    }, url) {
        try {
            var response = await destroyData(`/${url}`);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST',response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateStatus({
        commit, state
    }, url) {
        try {
            var response = await patchData(`/${url}`);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "created_at",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST',response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    SET_COMPANY(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.company = response.data
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    SET_LIST2(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list2 = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}